import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { AllInvoiceCollectionFragmentDoc } from '../fragments/allInvoiceCollection.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllInvoiceCollectionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllInvoiceCollectionsQuery = { __typename?: 'Query', invoiceCollections?: Array<{ __typename?: 'InvoiceCollection', id: string, name: string, scope: Types.InvoiceCollectionScope, invoice_email?: string | null, invoice_headline?: string | null, legal_name?: string | null, vat_number?: string | null, invoice_email_subject_prefix?: string | null, invoice_collection_debitor_account_number: number, billomat_client_id?: string | null, disable_automatic_partner_invoice_sending?: boolean | null, collapse_invoice_items?: boolean | null, store_ids?: Array<string | null> | null, type?: Types.StoreType | null, invoice_address?: { __typename?: 'Address', streetname?: string | null, streetno?: string | null, street_extra?: string | null, zip?: string | null, city?: string | null, country?: string | null } | null } | null> | null };


export const AllInvoiceCollectionsDocument = gql`
    query allInvoiceCollections {
  invoiceCollections {
    ...AllInvoiceCollection
  }
}
    ${AllInvoiceCollectionFragmentDoc}`;

/**
 * __useAllInvoiceCollectionsQuery__
 *
 * To run a query within a React component, call `useAllInvoiceCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInvoiceCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInvoiceCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllInvoiceCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<AllInvoiceCollectionsQuery, AllInvoiceCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllInvoiceCollectionsQuery, AllInvoiceCollectionsQueryVariables>(AllInvoiceCollectionsDocument, options);
      }
export function useAllInvoiceCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllInvoiceCollectionsQuery, AllInvoiceCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllInvoiceCollectionsQuery, AllInvoiceCollectionsQueryVariables>(AllInvoiceCollectionsDocument, options);
        }
export type AllInvoiceCollectionsQueryHookResult = ReturnType<typeof useAllInvoiceCollectionsQuery>;
export type AllInvoiceCollectionsLazyQueryHookResult = ReturnType<typeof useAllInvoiceCollectionsLazyQuery>;
export type AllInvoiceCollectionsQueryResult = Apollo.QueryResult<AllInvoiceCollectionsQuery, AllInvoiceCollectionsQueryVariables>;